class KnowledgeIqPair extends HTMLElement {
  constructor() {
    super();

    this.question = this.querySelector( 'div.knowledge-iq__question' );
    this.button = this.querySelector( 'button.knowledge-iq__question' );
    this.answer = this.querySelector( '.knowledge-iq__answer' );

    this.first_half = document.querySelector( '.knowledge-iq-container .grid__item.first-half' );
    this.second_half = document.querySelector( '.knowledge-iq-container .grid__item.second-half' );

    this.button.addEventListener( 'click', this.onButtonClick.bind( this ) )
  }

  onButtonClick(event) {
    event.preventDefault();
    let i = 1;
    let match_id = 0;
    let query_id = 'knowledge_pair_1';

    const display_status = getComputedStyle(this.answer).display;

    while ( document.getElementById( query_id ) ) {
      if ('#' + query_id === '#' + this.id) {
        match_id = i;
        document.getElementById( query_id ).style.display = 'block';

        let answer = this.answer;
        answer.style.display = ( display_status === 'block' ) ? 'none' : 'block';

        let qb = this.question;
        qb.style.margin = (display_status === 'block') ? 'inherit' : '0';

        let btn = this.button;
        let toggle_value = btn.ariaExpanded;
        btn.ariaExpanded = ( toggle_value == "false" ) ? true : false;
      }
      else {
        document.getElementById(query_id).style.display = ( display_status === 'block' ) ? 'block' : 'none';
      }
      i++;
      query_id = 'knowledge_pair_' + i;
    }

    // For two-column display, decide which side to hide when on of the answers is expanded
    if ( display_status === 'block' ) {
      this.first_half.style.display = 'block';
      this.second_half.style.display = 'block';
    }
    else {
      if ( match_id <= Math.round( (i - 1) / 2 ) ) {
        this.second_half.style.display = 'none';
      } else {
        this.first_half.style.display = 'none';
      }
    }
  }
}

customElements.define( 'knowledge-iq-pair', KnowledgeIqPair );